const playButton = document.querySelectorAll('.play-button');

playButton.forEach(function (el) {
    el.addEventListener('click', function () {
        //Select the video container
        const videoContainer = this.nextElementSibling;
        //Select the actual video element 2 levels deeper
        const video = videoContainer.firstElementChild.firstElementChild;

        //Remove the hide class from the video-container
        videoContainer.classList.remove('hide');
        //Add hide class to picture element
        videoContainer.nextElementSibling.classList.add('hide');
        //Play the video
        video.play();
    });
});
